import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { CashlessPayment, PurseTopupOptions } from '../models';
import {
  cashlessPaymentAction,
  ClearStateAction,
  getPursesAction,
  SetPurseTopupOptionsAction,
  SetSelectedPurseIDAction,
} from './purses.actions';
import { IPursesFeature } from './purses.feature.state';
import { getCashlessResponse, getFailures, getIsLoading, getPurses, getSelectedPurseID, getTopUpOptionResponse } from './purses.selectors';
import { BehaviorSubject } from 'rxjs';
import { filter } from 'rxjs/operators';

@Injectable()
export class PursesFacade {
  public isLoading$ = this.store.select(getIsLoading);
  public failures$ = this.store.select(getFailures);
  public purses$ = this.store.select(getPurses).pipe(filter((data) => data !== null));
  public getTopUpOptionResponse$ = this.store.select(getTopUpOptionResponse);
  public getCashlessResponse$ = this.store.select(getCashlessResponse);

  public selectedPurseID = new BehaviorSubject<number>(0);
  public selectedPurseID$ = this.selectedPurseID.asObservable();
  public purseID$ = this.store.select(getSelectedPurseID);

  constructor(private store: Store<IPursesFeature>) {}

  public getPurses(): void {
    this.store.dispatch(getPursesAction());
  }

  public setPurseTopupOptions(purseTopupOptions: PurseTopupOptions): void {
    this.store.dispatch(SetPurseTopupOptionsAction({ purseTopupOptions }));
  }
  public cashlessPayment(cashlessPayment: CashlessPayment): void {
    this.store.dispatch(cashlessPaymentAction({ cashlessPayment }));
  }
  public clearState(actionType: string): void {
    this.store.dispatch(ClearStateAction({ actionType }));
  }

  public getPurseID(id: number): void {
    this.selectedPurseID.next(id);
  }

  public setSelectedPurseID(selectedPurseID: number): void {
    this.store.dispatch(SetSelectedPurseIDAction({ selectedPurseID }));
  }
}
